import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=7f3d8090&scoped=true&"
var script = {}
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=7f3d8090&scoped=true&lang=css&"
import style1 from "./FooterMain.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FooterMain.vue?vue&type=style&index=2&id=7f3d8090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3d8090",
  null
  
)

export default component.exports